var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrizesMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77034 13.4536C6.88268 17.9527 10.4903 21.8899 14.9908 21.8899V21.8899V21.8899C19.5619 21.8899 23.0836 18.0162 23.209 13.4468C23.2244 12.8849 23.2325 12.3188 23.2325 11.7486C23.2325 9.05407 23.0685 6.41982 22.7899 3.92518C22.6885 3.01686 22.0046 2.28181 21.1031 2.13115C19.1275 1.80098 17.1001 1.60742 14.9908 1.60742C12.8768 1.60742 10.8127 1.78966 8.84573 2.126C7.95987 2.27747 7.29018 3.00046 7.18736 3.89328C6.89964 6.39181 6.74902 9.04413 6.74902 11.7486C6.74902 12.3213 6.75626 12.8896 6.77034 13.4536Z",
    fill: "#1D202B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77034 13.4536C6.88268 17.9527 10.4903 21.8899 14.9908 21.8899V21.8899V21.8899C19.5619 21.8899 23.0836 18.0162 23.209 13.4468C23.2244 12.8849 23.2325 12.3188 23.2325 11.7486C23.2325 9.05407 23.0685 6.41982 22.7899 3.92518C22.6885 3.01686 22.0046 2.28181 21.1031 2.13115C19.1275 1.80098 17.1001 1.60742 14.9908 1.60742C12.8768 1.60742 10.8127 1.78966 8.84573 2.126C7.95987 2.27747 7.29018 3.00046 7.18736 3.89328C6.89964 6.39181 6.74902 9.04413 6.74902 11.7486C6.74902 12.3213 6.75626 12.8896 6.77034 13.4536Z",
    stroke: "#424A63",
    strokeWidth: 3.21429
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9912 21.9062V28.3934",
    stroke: "#424A63",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83984 28.3936H20.142",
    stroke: "#424A63",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7178 3.66797H26.2411C27.4246 3.66797 28.384 4.62736 28.384 5.81083V6.18923C28.384 8.19527 27.7327 10.1192 26.5735 11.5376C25.6589 12.6569 24.4871 13.3891 23.228 13.6483",
    stroke: "#424A63",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20801 3.66797H3.75709C2.57363 3.66797 1.61424 4.62736 1.61424 5.81083V6.18923C1.61424 8.19527 2.26548 10.1192 3.4247 11.5376C4.33431 12.6507 5.49823 13.381 6.74934 13.6439",
    stroke: "#424A63",
    strokeWidth: 3.21429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizesMenuIcon);
export default __webpack_public_path__ + "static/media/prizes-menu-icon.7c5d1b101f78e66c503aa4e2b491924a.svg";
export { ForwardRef as ReactComponent };